import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import {
  getConnection,
  getErrorMessage,
  hideSpinner,
  ignoreSpecialCharacters,
  showSpinner,
} from 'src/app/core/services/functions.service';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { map, startWith } from 'rxjs/operators';
import { OpcionesMenuService } from '../../services/opciones.service';
import { ActivatedRoute } from '@angular/router';
import { arrayNotEmpty } from 'class-validator';
import { RolesService } from '../../services/roles.service';
import { UserRoleSicfModel } from '../../models/user-role.model';
import { OpcionMenuSicfModel } from '../../models/opcion-menu.model';

@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.scss'],
})
export class RolesComponent implements OnInit {
  roles: any[] = [];
  options: any[] = [];
  selectedOptions: any[] = [];
  obtionsByRole: any[] = [];
  selectedOptionsToDelete: any[] = [];
  selectedRole: UserRoleSicfModel | undefined;

  form: FormGroup;
  filteredIcons: Observable<string[]>;

  constructor(
    private helpers: HelpersService,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private rolesService: RolesService,
    private opcionesService: OpcionesMenuService
  ) {
    this.form = this.formBuilder.group({
      codigo_rol: [''],
      estado: ['', [Validators.required, Validators.maxLength(1)]],
      descripcion_rol: ['', [Validators.required]],
    });
    this.resetForm();
  }

  async ngOnInit() {
    const data = this.activatedRoute.snapshot.data;
    if (data.title) {
      this.helpers.setTitle(data.title);
    }
    await this.getAllRoles();
    await this.getAllOptions();
  }

  resetForm(selectedRole: UserRoleSicfModel | undefined = undefined) {
    if (selectedRole == undefined) {
      this.selectedRole = undefined;
      this.form.reset();
    } else {
      this.form.get('codigo_rol')?.setValue(selectedRole?.codigo_rol);
      this.form.get('estado')?.setValue(selectedRole?.estado);
      this.form.get('descripcion_rol')?.setValue(selectedRole?.descripcion_rol);
    }
  }

  resetOptions(options: OpcionMenuSicfModel[]) {
    this.options = [];
    this.selectedOptions = [];
    this.obtionsByRole = [];
    this.selectedOptionsToDelete = [];
    //esperamos para que el componente se recargue
    // setTimeout(() => {
    this.options = options;
    // }, 300);
  }

  async getAllRoles() {
    showSpinner();
    try {
      const result = await this.rolesService.findAll();
      if (result.success) {
        this.roles = result.data;
        console.log(this.roles);
      } else {
        this.helpers.notifications.errorMessage(result.message);
      }
    } catch (error) {
      const message = getErrorMessage(error);
      this.helpers.notifications.errorMessage(message);
    }
    hideSpinner();
  }

  async getAllOptions(fromRoles: boolean = false) {
    showSpinner();
    try {
      let result;
      if (fromRoles && this.selectedRole && this.selectedRole.codigo_rol) {
        this.obtionsByRole = [];
        result = await this.opcionesService.findAllByRole(
          this.selectedRole.codigo_rol
        );
        this.obtionsByRole = result.data;
      }
      this.options = [];
      result = await this.opcionesService.findAll(
        '',
        [
          'op.codigo_opcion as codigo',
          `mo.descripcion_modulo as modulo`,
          'descripcion_opcion as opcion',
          'estado',
          'mo.codigo_modulo',
        ],
        this.obtionsByRole.map((value) => {
          return `'${value.codigo}'`;
        })
      );
      this.options = result.data;
    } catch (error) {
      const message = getErrorMessage(error);
      this.helpers.notifications.errorMessage(message);
    }
    hideSpinner();
  }

  async getOneRole(codigo: string) {
    try {
      const result = await this.rolesService.findOne(codigo);
      if (result.success) {
        return result.data;
      } else {
        this.helpers.notifications.errorMessage(result.message);
        return null;
      }
    } catch (error) {
      const message = getErrorMessage(error);
      this.helpers.notifications.errorMessage(message);
      return null;
    }
  }

  async setSelectedRole(selected: any[]) {
    showSpinner();
    this.resetOptions(this.options);
    if (arrayNotEmpty(selected) && selected[0].codigo) {
      this.selectedRole = undefined;
      this.selectedRole = await this.getOneRole(selected[0].codigo);
      if (this.selectedRole && this.selectedRole.codigo_rol) {
        this.getAllOptions(true);
        this.resetForm(this.selectedRole);
      }
    }
    hideSpinner();
  }

  async selectOptionToAssign(selected: any[]) {
    showSpinner();
    this.selectedOptions = selected;
    hideSpinner();
  }

  async selectOptionsToDelete(selected: any[]) {
    showSpinner();
    this.selectedOptionsToDelete = selected;
    hideSpinner();
  }

  async asignarOpciones() {
    showSpinner();
    if (
      this.selectedOptions.length > 0 &&
      this.selectedRole &&
      this.selectedRole.codigo_rol
    ) {
      try {
        const result = await this.rolesService.asignarOpciones(
          this.selectedRole.codigo_rol,
          this.selectedOptions
        );
        this.resetOptions(this.options);
        await this.getAllOptions(true);
        if (result.success) {
          this.helpers.notifications.successMessage(result.message);
        } else {
          this.helpers.notifications.errorMessage(result.message);
        }
        hideSpinner();
      } catch (error) {
        hideSpinner();
        const message = getErrorMessage(error);
        this.helpers.notifications.errorMessage(message);
      }
    } else {
      hideSpinner();
      this.helpers.notifications.errorMessage(
        'Debe seleccionar un rol y por lo menos una opcion'
      );
    }
  }

  async eliminarOpciones() {
    showSpinner();
    if (
      this.selectedOptionsToDelete.length > 0 &&
      this.selectedRole &&
      this.selectedRole.codigo_rol
    ) {
      try {
        const result = await this.rolesService.eliminarOpciones(
          this.selectedRole.codigo_rol,
          this.selectedOptionsToDelete
        );
        this.resetOptions(this.options);
        await this.getAllOptions(true);
        if (result.success) {
          this.helpers.notifications.successMessage(result.message);
        } else {
          this.helpers.notifications.errorMessage(result.message);
        }
        hideSpinner();
      } catch (error) {
        hideSpinner();
        const message = getErrorMessage(error);
        this.helpers.notifications.errorMessage(message);
      }
    } else {
      hideSpinner();
      this.helpers.notifications.errorMessage(
        'Debe seleccionar un rol y por lo menos una opcion'
      );
    }
  }

  print(value) {
    return JSON.stringify(value);
  }

  ignoreSpecialCharactersVoid(controlName: string, value: string) {
    let hola = ignoreSpecialCharacters(value);
    this.form.get(controlName)?.setValue(hola);
    return hola;
  }

  async create() {
    showSpinner();
    if (this.form.valid) {
      try {
        const result = await this.rolesService.create(this.form.value);
        if (result.success) {
          await this.getAllRoles();
          this.helpers.notifications.successMessage(result.message);
        } else {
          this.helpers.notifications.errorMessage(result.message);
        }
        hideSpinner();
      } catch (error) {
        hideSpinner();
        const message = getErrorMessage(error);
        this.helpers.notifications.errorMessage(message);
      }
    } else {
      hideSpinner();
      this.helpers.notifications.errorMessage(
        'Debe completar algunos campos o son demasiado largos'
      );
    }
  }

  async modify() {
    showSpinner();
    if (this.form.valid && this.selectedRole && this.selectedRole.codigo_rol) {
      try {
        const result = await this.rolesService.update(this.form.value, {
          c_emp: getConnection(),
          codigo_rol: this.selectedRole?.codigo_rol,
        });
        if (result.success) {
          await this.getAllRoles();
          await this.setSelectedRole([
            { codigo: result.data.current[0].codigo_rol },
          ]);
          this.helpers.notifications.successMessage(result.message);
        } else {
          this.helpers.notifications.errorMessage(result.message);
        }
        hideSpinner();
      } catch (error) {
        hideSpinner();
        const message = getErrorMessage(error);
        this.helpers.notifications.errorMessage(message);
      }
    } else {
      hideSpinner();
      this.helpers.notifications.errorMessage(
        'Debe completar algunos campos o son demasiado largos'
      );
    }
  }
}
